import React, { useState } from "react";
import styles from "./ProfileSidebar.module.scss";
import { IoClose } from "react-icons/io5";
import { toggleProfileSidebar } from "../model/slice";
import { useDispatch, useSelector } from "react-redux";
import { selectIsProfileSidebarOpen } from "../model/selector";
import axios from "@/shared/api/axios";
import { AUTH_ENDPOINTS } from "@/shared/api/apiEndpoints";
import { Button, Modal } from "antd";

export const ProfileSidebar = () => {
    const dispatch = useDispatch();
    const isProfileSidebarOpen = useSelector(selectIsProfileSidebarOpen);
    const [withdrawModalOpen, setWithdrawModalOpen] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    // 탈퇴 모달 열기 (딜레이 포함)
    const showWithdrawModal = () => {
        setShowConfirmModal(true);
    };

    // 탈퇴 확인 처리
    const handleWithdrawOk = () => {
        setShowConfirmModal(false);
        console.log('계정 탈퇴 완료');
        
    };

    // 탈퇴 모달 취소
    const handleWithdrawCancel = () => {
        setShowConfirmModal(false);
    };

    const handleToggleProfileSidebar = () => {
        dispatch(toggleProfileSidebar());
    };

    const handleLogout = async () => {
        try {
            await axios.post(AUTH_ENDPOINTS.LOGOUT);
            // landing 페이지로 이동
            window.location.href = '/';
            console.log('로그아웃 성공');
            // 로그아웃 후 필요한 추가 작업을 여기에 구현
        } catch (error) {
            console.error('로그아웃 실패:', error);
        }
    };

    return (
        <>
            <div
                className={`${styles.overlay} ${isProfileSidebarOpen ? styles.open : ""}`}
                onClick={handleToggleProfileSidebar}
            />
            <div className={`${styles.sidebar} ${isProfileSidebarOpen ? styles.open : ""}`}>
                <div className={styles.sidebarHeader}>
                    <div className={styles.userName}>프로필</div>
                    <IoClose
                        className={styles.closeIcon}
                        onClick={handleToggleProfileSidebar}
                    />
                </div>
                <div className={styles.profileContent}>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Button type="primary" onClick={handleLogout}>로그아웃</Button>
                        <Button 
                            type="primary" 
                            danger 
                            size="middle"
                            onClick={showWithdrawModal}
                            style={{ 
                                backgroundColor: '#ff4d4f', 
                                borderColor: '#ff4d4f',
                                color: 'white'
                            }}
                        >
                            계정탈퇴
                        </Button>
                    </div>
                </div>

            </div>
            {/* 탈퇴 확인 모달 */}
            <Modal
                title="탈퇴 확인"
                open={showConfirmModal}
                onOk={handleWithdrawOk}
                onCancel={handleWithdrawCancel}
                okText="확인"
                cancelText="취소"
                okButtonProps={{ 
                    danger: true,
                    style: { backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }
                }}
                centered
            >
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                        정말 계정을 탈퇴하시겠습니까?
                    </p>
                    <p style={{ color: '#ff4d4f', fontSize: '14px' }}>
                        탈퇴 시 모든 데이터가 삭제되며 복구할 수 없습니다.
                    </p>
                </div>
            </Modal>
        </>
    );
}; 